import { useEffect } from "react";

export default function AgencyStorySection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-brand-black py-28 md:py-40 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/ff8973f827805d058230b8170cfb38aa.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-black via-brand-black/95 to-brand-black/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Year */}
          <div className="reveal flex items-center justify-center lg:justify-start">
            <div className="relative">
              <span
                className="font-display font-black text-gold/10 select-none leading-none"
                style={{ fontSize: "clamp(6rem, 18vw, 16rem)" }}
              >
                2024
              </span>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <p className="text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase mb-2">
                    Founded
                  </p>
                  <div className="w-16 h-px bg-gold mx-auto" />
                </div>
              </div>
            </div>
          </div>

          {/* Right: Story */}
          <div className="reveal reveal-delay-1">
            <span className="text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase block mb-6">
              Our Story
            </span>
            <h2 className="font-display font-black text-white leading-tight mb-8"
              style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
              Founded on{" "}
              <span className="text-gradient-gold">Creativity</span> &amp;{" "}
              <span className="text-gradient-gold">Community</span>
            </h2>
            <p className="text-white/65 font-sans text-lg leading-relaxed">
              Founded in 2024, The LittyCity Agency LLC was created to give
              creators real support, real strategy, and real opportunities. We
              mix corporate polish with community energy to help hosts and
              brands grow with confidence.
            </p>
            <p className="text-white/65 font-sans text-lg leading-relaxed mt-4">
              We believe every creator deserves the tools, structure, and
              mentorship to thrive in today&apos;s digital landscape — and
              that&apos;s exactly what we provide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
